import { AppSpinner } from "components/AppSpinner/AppSpinner";
import { FilteringCombobox } from "components/controls/FilteringCombobox";
import { useAppTheme } from "hooks/useAppTheme";
import useGetCountryOptionsPerUser from "hooks/useGetCountryOptionsPerUser";
import { useAtom, useSetAtom } from "jotai";
import { devices } from "library/constants";
import { formatCompanyLabel, lightenColor } from "library/utils";
import { useTranslation } from "react-i18next";
import { useGetClientsByCountry } from "state/queries/useGetClientsByCountry";
import {
  selectedCompanyState as selectedCompanyStateCompanyPage,
  selectedCountryState as selectedCountryStateCompanyPage,
} from "store/UICompanyPage";
import { selectedCompanyState } from "store/UIHrPage";
import styled from "styled-components";
import { HrRefreshBtn } from "./HrRefreshBtn";

export function HubPageSection() {
  const { t } = useTranslation();
  const { palette } = useAppTheme();
  const setSelectedCountryCompanyPage = useSetAtom(
    selectedCountryStateCompanyPage
  );

  const [selectedCompany, setSelectedCompany] = useAtom(selectedCompanyState);

  const setSelectedCompanyCompanyPage = useSetAtom(
    selectedCompanyStateCompanyPage
  );

  const countryOption = useGetCountryOptionsPerUser();

  const {
    data: companyOptions,
    isLoading: companyOptionsLoading,
    isRefetching: companyOptionsRefetching,
  } = useGetClientsByCountry({
    countryCode: 0,
  });

  if (companyOptionsLoading) return <AppSpinner />;

  return (
    <Container>
      <SelectItemsWrap>
        <HrRefreshBtn />
        <FilteringCombobox
          data-help="subheader-client-select"
          disabled={companyOptionsLoading || companyOptionsRefetching}
          appearance="outline"
          style={{
            width: "100%",
            background: lightenColor(palette.purpleLight),
            borderColor: palette.neutralLight,
          }}
          placeholder={t("hbh.selectCompany.label")}
          error={selectedCompany?.value ? "" : t("hbh.companyIsRequired.label")}
          setFieldValue={(_, value) => {
            const country = countryOption.find(
              (item) => item.value === value?.countryCode
            );

            setSelectedCompany(value);
            //set default country and company na company page
            setSelectedCountryCompanyPage(country || null);
            setSelectedCompanyCompanyPage({
              ...value,
              internalNumber: value?.clientInternalNumberGOS,
              countryCodeId: value?.countryCode,
              currencyCodeId: value?.currencyCode,
              //name stays the plain company name, the partner number is only added
              //to the label shown in the selects
              name: value?.clientName,
              label: formatCompanyLabel(value),
            });
          }}
          value={selectedCompany as any}
          label={t("hbh.company.label")}
          noLabel
          noErrorSection
          options={companyOptions || []}
          name={"company"}
        />
      </SelectItemsWrap>
    </Container>
  );
}

const Container = styled.div`
  display: flex;

  // position: sticky;
  // top: 0;

  flex-direction: column;
  gap: 20px;
  @media only screen and ${devices.md} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const SelectItemsWrap = styled.div`
  width: 300px;
  gap: 10px;
  display: flex;
  flex-wrap: wrap;

  @media only screen and ${devices.md} {
    flex-direction: row;
    justify-content: space-between;
    width: 400px;
    flex-wrap: nowrap;
  }
`;
